import Typography from "@mui/material/Typography";
import isEmpty from "lodash/isEmpty";
import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { COPYRIGHT } from "../../constants/appConstants";
import {
  getBrandMenuItems,
  isExternalLink,
  isValidLink,
  sortByOrderBrand,
} from "../../helper/helper";
import useCmsStore from "../../store/cmsStore";
import styles from "./Footer.module.scss";
import logo from "../../assets/Logo/logo.svg";
import SocialMediaIconWrapper from "./SocialMediaIconWrapper";
import LinksContainer from "./LinksContainer";
import MediaListWrapper from "./MediaListWrapper";

const Footer = () => {
  const { t } = useTranslation();
  const { fetchOurBrands, ourBrands, fetchFooter, footer, routeList, fetchRouteList } =
    useCmsStore();

  useEffect(() => {
    fetchOurBrands();
    fetchFooter();
    fetchRouteList();
  }, [fetchOurBrands, fetchFooter]);

  // Memoize menu items
  const menuItems: any = useMemo(
    () => getBrandMenuItems(ourBrands),
    [ourBrands]
  );
  // Memoize quick links
  const quickLinks = useMemo(
    () =>
      (routeList?.FooterQuickLinks ?? [])
        .filter((item: any) => isValidLink(item?.Path))
        .map((item: any) => ({
          label: item?.Label ?? "",
          path: item?.Path ?? "",
        })),
    [routeList],
  );
  const orderedBrandLinks = useMemo(
    () =>
      sortByOrderBrand(menuItems || [])
        .filter((item: any) => isExternalLink(item?.path))
        .map((item: any) => ({
          label: item?.label ?? "",
          path: item?.path ?? "",
        })),
    [menuItems],
  );
  const quicklinkHeading = routeList?.FooterQuickLinksHeading ?? "";
  const mediaList = useMemo(
    () =>
      (footer?.attributes?.mediaCollection ?? []).filter((item: any) => isExternalLink(item?.Link)),
    [footer],
  );

  const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.location.href = "/";
    }
  };

  return (
    <>
      <div className={styles.footerWrapper}>
        <div className={styles.addressContainer}>
          <div className={styles.logoContainer}>
            <Link to="/" className={styles.logoLink} onClick={handleLogoClick}>
              <img src={logo} alt="Dutton Automotive" className={styles.logo} />
            </Link>
          </div>
          <div className={styles.address}>
            {!isEmpty(footer?.attributes?.Location) && (
              <div
                className={styles.locationWrapper}
                dangerouslySetInnerHTML={{
                  __html: footer?.attributes?.Location,
                }}
              />
            )}
            {!isEmpty(footer?.attributes?.Address) && (
              <div
                className={styles.addressWrapper}
                dangerouslySetInnerHTML={{
                  __html: footer?.attributes?.Address,
                }}
              />
            )}
          </div>
          <SocialMediaIconWrapper footer={footer?.attributes} />
        </div>
        <LinksContainer heading={t("header.ourBrands")} list={orderedBrandLinks} />
        <LinksContainer heading={quicklinkHeading} list={quickLinks} />
      </div>
      <MediaListWrapper mediaList={mediaList} />
      <div className={styles.copyRightContainer}>
        <Typography variant="body2" align="center">
          {COPYRIGHT}
        </Typography>
      </div>
    </>
  );
};

export default Footer;
